<template>
    <div>
        <div class="statistics">
            <Row class="row">
                <span style="line-height:40px">广告投放统计</span>
            </Row>
            <Row>
                <Col span="8">
                    <div class="box">
                        <div>
                            今日投放广告数
                        </div>
                        <div class="count">
                            {{ad_count}}
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div>
                            今日曝光次数（次）
                        </div>
                        <div class="count">
                            {{exposure_count}}
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div>
                            今日点击次数（次）
                        </div>
                        <div class="count">
                            {{click_count}}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="statistics">
            <Row class="row">
                <span style="line-height:40px">版位统计</span>
            </Row>
            <Row>
                <Col span="8">
                    <div class="box">
                        <div>
                            今日投放版位
                        </div>
                        <div class="count">
                            {{working_placements_count}}
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div>
                            未投放版位
                        </div>
                        <div class="count">
                            {{idle_placements_count}}
                        </div>
                    </div>
                </Col>
            </Row>
            <Row class="row" style="margin-top:0px">
                <span style="line-height:40px">今日版位投放</span>
            </Row>
            <Table :columns="columns" :data="data" style="margin:20px">
            </Table>
            <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
            <br>
        </div>
        <div class="statistics">
            <Row class="row">
                <span style="line-height:40px">流量排行</span>
            </Row>
            <Row style="margin: 0 20px 10px; align-items:center;">
                <Select v-model="rankingType" style="width:140px; margin-right:8px" @on-change="handleRankingTypeChange">
                    <Option value="placement">版位排行</Option>
                    <Option value="plan">投放计划排行</Option>
                </Select>
                <DatePicker type="date" :value="rankingParams.date" placeholder="不选默认昨日" style="width:160px; margin-right:8px" @on-change="handleRankingDateChange"></DatePicker>
                <span style="margin-right:6px;color:#666;">排序方式：</span>
                <Select v-model="rankingParams.order_by" style="width:160px; margin-right:12px" @on-change="handleRankingFilterChange">
                    <Option value="exposure_count">曝光量</Option>
                    <Option value="click_count">点击量</Option>
                    <Option value="order_count">订单量</Option>
                    <Option value="ctr">点击率</Option>
                    <Option value="conversion_rate">点击成交率</Option>
                </Select>
                <RadioGroup v-model="rankingParams.sort" @on-change="handleRankingFilterChange" style="margin-right:12px">
                    <Radio label="desc">降序</Radio>
                    <Radio label="asc">升序</Radio>
                </RadioGroup>
                <Checkbox v-model="rankingOrderOnly" @on-change="handleOrderFlagChange">仅展示商业化广告</Checkbox>
            </Row>
            <Table :columns="rankingColumns" :data="rankingData" style="margin:20px"></Table>
            <Page show-total :current="rankingPage" @on-change="changeRankingPage" style="margin-top: 10px; text-align: right" :total="rankingTotal" :page-size="20"/>
            <br>
        </div>
    </div>
</template>

<script>
import{todayPlacementData, todayAdList, placementFlowRanking, planFlowRanking}from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'home',
    meta:{
        keepAlive: true // 开启缓存
    },
    components: {
        
    },
    data () {
        return {
            ad_count: 0,
            exposure_count: 0,
            click_count: 0,
            working_placements_count: 0,
            idle_placements_count: 0,
            columns: [
                {
                    title: '版位类型',
                    key: 'category',
                    align: 'center'
                },
                {
                    title: '应用名称',
                    key: 'medium_name',
                    align: 'center'
                },
                {
                    title: '版位名称',
                    key: 'placement_name',
                    align: 'center'
                },
                {
                    title: '广告名称',
                    key: 'title',
                    align: 'center'
                },
                {
                    title: '今日曝光次数',
                    key: 'exposure_count',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', {
                            style: {
                                color: '#2d8cf0'
                            }
                        },params.row.exposure_count+'次');
                    }
                },
                {
                    title: '今日点击次数',
                    key: 'click_count',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', {
                            style: {
                                color: '#2d8cf0'
                            }
                        },params.row.click_count+'次');
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    render: (h, params) => {
                        return h("div", [
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                this.$router.push({
                                    name: "statistics",
                                    query: {
                                        placement_id: params.row.placement_id,
                                        plan_id: params.row.plan_id,
                                    },
                                });
                                },
                            },
                            },"查看详情")
                        ]);
                    },
                }
            ],
            data: [],
            total_count:0,
            page:1,
            rankingType: 'placement',
            rankingColumnsPlacement: [
                {
                    title: '排名',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', {}, (this.rankingPage - 1) * 20 + params.index + 1)
                    }
                },
                {
                    title: '版位名称',
                    key: 'placement_name',
                    align: 'center'
                },
                {
                    title: '曝光量',
                    key: 'exposure_count',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', { style: { color: '#2d8cf0' } }, params.row.exposure_count)
                    }
                },
                {
                    title: '点击量',
                    key: 'click_count',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', { style: { color: '#2d8cf0' } }, params.row.click_count)
                    }
                },
                {
                    title: '订单量',
                    key: 'order_count',
                    align: 'center'
                },
                {
                    title: '点击率',
                    key: 'ctr',
                    align: 'center',
                    render: (h, params) => {
                        const v = params.row.ctr
                        return h('span', {}, (v != null ? v : 0) + '%')
                    }
                },
                {
                    title: '点击成交率',
                    key: 'conversion_rate',
                    align: 'center',
                    render: (h, params) => {
                        const v = params.row.conversion_rate
                        return h('span', {}, (v != null ? v : 0) + '%')
                    }
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        return h('Button', {
                            props: { type: 'text', size: 'small' },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: 'placementStatistics',
                                        query: { placement_id: params.row.placement_id }
                                    })
                                }
                            }
                        }, '查看数据统计')
                    }
                }
            ],
            rankingColumnsPlan: [
                {
                    title: '排名',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', {}, (this.rankingPage - 1) * 20 + params.index + 1)
                    }
                },
                {
                    title: '计划名称',
                    key: 'plan_name',
                    align: 'center'
                },
                {
                    title: '版位名称',
                    key: 'placement_name',
                    align: 'center'
                },
                {
                    title: '曝光量',
                    key: 'exposure_count',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', { style: { color: '#2d8cf0' } }, params.row.exposure_count)
                    }
                },
                {
                    title: '点击量',
                    key: 'click_count',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', { style: { color: '#2d8cf0' } }, params.row.click_count)
                    }
                },
                {
                    title: '订单量',
                    key: 'order_count',
                    align: 'center'
                },
                {
                    title: '点击率',
                    key: 'ctr',
                    align: 'center',
                    render: (h, params) => {
                        const v = params.row.ctr
                        return h('span', {}, (v != null ? v : 0) + '%')
                    }
                },
                {
                    title: '点击成交率',
                    key: 'conversion_rate',
                    align: 'center',
                    render: (h, params) => {
                        const v = params.row.conversion_rate
                        return h('span', {}, (v != null ? v : 0) + '%')
                    }
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: { type: 'text', size: 'small' },
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: 'planStatistics',
                                            query: { plan_id: params.row.plan_id }
                                        })
                                    }
                                }
                            }, '查看数据统计')
                        ])
                    }
                }
            ],
            rankingData: [],
            rankingTotal: 0,
            rankingPage: 1,
            rankingParams: {
                date: '',
                order_by: 'exposure_count',
                sort: 'desc',
                order_flag: '0',
                page_size: 20
            },
            rankingOrderOnly: false
        }
    },
    computed: {
        rankingColumns() {
            return this.rankingType === 'plan' ? this.rankingColumnsPlan : this.rankingColumnsPlacement
        }
    },
    methods:{
        getTodayAdList(page=1,page_size=20){
            todayAdList({page,page_size}).then(res=>{
                if(res.data.code==200){
                    this.data=res.data.data.ad_list
                    this.total_count=res.data.data.total
                    this.page = page
                }
            })
        },
        getTodayPlacementData(){
            todayPlacementData().then(res=>{
                if(res.data.code==200){
                    this.ad_count = res.data.data.statistics_data.ad_count
                    this.exposure_count = res.data.data.statistics_data.exposure_count
                    this.click_count = res.data.data.statistics_data.click_count
                    this.working_placements_count = res.data.data.statistics_data.working_placements_count
                    this.idle_placements_count = res.data.data.statistics_data.idle_placements_count
                }
            })
        },
        changePage(page){
            this.getTodayAdList(page,20);
        },
        handleRankingDateChange(date) {
            this.rankingParams.date = date
            this.getFlowRanking(1)
        },
        handleRankingFilterChange() {
            this.getFlowRanking(1)
        },
        changeRankingPage(page) {
            this.getFlowRanking(page)
        },
        handleOrderFlagChange(checked) {
            this.rankingParams.order_flag = checked ? '1' : '0'
            this.getFlowRanking(1)
        },
        handleRankingTypeChange() {
            this.getFlowRanking(1)
        },
        getFlowRanking(page = 1) {
            const p = {
                date: this.rankingParams.date,
                order_by: this.rankingParams.order_by,
                sort: this.rankingParams.sort,
                order_flag: this.rankingParams.order_flag,
                page,
                page_size: this.rankingParams.page_size
            }
            const api = this.rankingType === 'plan' ? planFlowRanking : placementFlowRanking
            api(p).then(res => {
                if (res.data && res.data.code === 200) {
                    const d = res.data.data || {}
                    this.rankingData = d.ranking_list || []
                    this.rankingTotal = d.total || 0
                    this.rankingPage = d.current_page || page
                }
            })
        }
    },
    created() {
        Cookies.set('active_name', '1');
        this.getTodayPlacementData()
        this.getTodayAdList(1,20)
        const dt = new Date()
        dt.setDate(dt.getDate() - 1)
        const y = dt.getFullYear()
        const m = ('0' + (dt.getMonth() + 1)).slice(-2)
        const d = ('0' + dt.getDate()).slice(-2)
        this.rankingParams.date = `${y}-${m}-${d}`
        this.getFlowRanking(1)
    },
    activated() {
        // 在这里刷新列表
        this.getTodayAdList(this.page,20)
    },
}
</script>
<style scoped>
.banner{
  width: 100%;
  max-height: 120px;
  min-height: 120px;
  /* border:1px solid; */
  background: white;
}
.statistics{
  width: 100%;
  /* border:1px solid; */
  background: white;
  /* margin-top: 20px; */
}
.row{
  margin: 10px 20px 10px;
}
.box{
  width: 200px;
  height: 120px;
  border:1px solid;
  margin: 0px 20px 20px;
}
.box .count{
  width: 100%;
  height: 60%;
  line-height: 60px;
  text-align: center;
  /* font-display: center; */
  font-size: 24px;
}
.box div{
  width: 100%;
  height: 40%;
  line-height: 59px;
  text-align: center;
  /* font-display: center; */
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue